import { useState, useEffect } from 'react';

import { InitialsAvatar, RowPhoto } from '../styles';

// Panel kart satırlarının avatarı. Kural: kullanıcı listelenen HER yerde profil
// fotoğrafı varsa o gösterilir; yoksa (ya da adres kırıksa) panelin kendi
// baş-harf rozetine düşülür. `ui/Avatar` kullanılmadı: onun geri düşüş rengi
// (primary.light + beyaz metin) panel kartlarının görsel dilinden farklı ve
// satırların rengini sessizce değiştirirdi.
export default function RowAvatar({ src, name, initials, size }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);

  if (src && !broken) {
    return <RowPhoto $size={size} src={src} alt={name || ''} onError={() => setBroken(true)} />;
  }
  return <InitialsAvatar $size={size}>{initials}</InitialsAvatar>;
}
